import * as React from 'react';

import { client } from '@admin/libraries/apollo';
import { useOrderEstimatedCuftQuery } from '@admin/schema';

export const EstimatedCUFT: React.FC<{
  orderID: number;
}> = ({ orderID }) => {
  const { data, loading, error } = useOrderEstimatedCuftQuery({
    client,
    variables: { orderID: String(orderID) },
  });
  if (error) {
    return (
      <span title={error.message} className="text-danger">
        Failed to load
      </span>
    );
  }
  if (loading) {
    return <span>Loading…</span>;
  }
  if (!data?.order) {
    return <span>—</span>;
  }
  const cuft = data.order.estimatedCuft;
  if (cuft == null || !Number.isFinite(cuft)) {
    return <span>—</span>;
  }
  return <>{cuft.toFixed(2)}</>;
};
